export interface IBaseDataObject {
    id?: string;

    createdBy?: string;
    createdOn?: Date;
    lastSavedBy?: string;
    lastSavedOn?: Date;
}

export interface IBaseDataObjectWithSaveMethods {
    beforeSave(): void;

    afterSave(): void;
}

export class BaseDataObject implements IBaseDataObject {
    id?: string;

    createdBy?: string;
    createdOn?: Date;
    lastSavedBy?: string;
    lastSavedOn?: Date;
}
